import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, isRef as _isRef, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-e0f2f724"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["id"];
const _hoisted_2 = {
  class: "category-header"
};
const _hoisted_3 = {
  class: "m-1 btn btn-dark font-weight-bold"
};
const _hoisted_4 = {
  style: {
    "padding-bottom": "5px"
  }
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb-1 d-flex justify-content-center border-bottom"
}, null, -1));

const _hoisted_6 = ["id"];
const _hoisted_7 = {
  class: "li-file-number"
};
const _hoisted_8 = {
  class: "pl-3 justify-content-center"
};
const _hoisted_9 = {
  class: "mb-1 h6 font-weight-bold"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-text text-muted small"
}, "Fantasy955", -1));

const _hoisted_11 = {
  class: "text-muted"
};
const _hoisted_12 = {
  key: 0,
  class: "card-text mr-1 mt-2"
};
const _hoisted_13 = {
  key: 1,
  class: "card-text mr-1 mt-2 pb-2"
};
const _hoisted_14 = {
  key: 2,
  class: "category-footer pl-3 pb-2"
};
const _hoisted_15 = {
  class: "text-muted card-text small",
  style: {
    "padding": "0",
    "margin": "0"
  }
};
const _hoisted_16 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_17 = {
  class: "text-muted card-text small",
  style: {
    "padding": "0",
    "margin": "0"
  }
};
const _hoisted_18 = ["label", "value"];
import { onMounted, inject, computed, ref, watch, watchEffect } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElSelect, ElOption } from 'element-plus';
import 'element-plus/es/components/select/style/css';
import { debounce } from '@/utils/common';
export default {
  __name: 'HomeBlogCategory',
  props: {
    categoryInfo: {
      type: Object,
      required: true
    }
  },

  setup(__props) {
    const probs = __props;
    const globalParams = inject("globalParams");
    const route = useRoute();
    const router = useRouter();
    const itemPerPageOptions = [5, 10, 15, 20];
    var max_file_items = globalParams.max_file_items;
    max_file_items = ref(max_file_items);
    const main = ref(null);
    const keyword = ref("");
    var pageIndex = 1;
    pageIndex = ref(pageIndex);
    var layaside = false;
    layaside = ref(layaside);
    const baseIndex = ref(0);
    const filteredFiles = computed({
      get() {
        return probs.categoryInfo.files.filter(item => {
          return item.name.toLowerCase().indexOf(keyword.value.toLowerCase()) != -1;
        });
      }

    });
    const readMore = computed({
      get() {
        return filteredFiles.value.length > max_file_items.value;
      },

      set(newValue) {
        console.log("set");
      }

    });
    const totalPage = computed(() => {
      return Math.max(1, Math.ceil(filteredFiles.value.length / max_file_items.value));
    });
    const currentPageFiles = computed(() => {
      if (max_file_items.value != Infinity) {
        let start = (pageIndex.value - 1) * max_file_items.value;
        return filteredFiles.value.filter((item, index) => {
          return index >= start && index < start + max_file_items.value;
        });
      } else {
        return filteredFiles.value;
      }
    });

    function showAll() {
      baseIndex.value = 0;
      max_file_items.value = Infinity;
      layaside.value = true;
    }

    function layAside(event) {
      baseIndex.value = 0;
      max_file_items.value = globalParams.max_file_items;
      layaside.value = false;
      let div = document.getElementById(`div-${probs.categoryInfo.sname}`);
      div.scrollIntoView({
        behavior: "smooth"
      });
    }

    function viewBlog(file) {
      router.push({
        name: "blog",
        params: {
          path: file.relapath,
          categorySname: probs.categoryInfo.sname,
          blogName: file.name
        }
      });
    }

    function prePage(event) {
      pageIndex.value--;
      baseIndex.value = (pageIndex.value - 1) * max_file_items.value;
    }

    function nextPage(event) {
      pageIndex.value++;
      baseIndex.value = (pageIndex.value - 1) * max_file_items.value;

      if (pageIndex.value == totalPage.value) {
        document.getElementById(main.value.id).scrollIntoView({
          behavior: "smooth"
        });
      }
    }

    const handleKeywordChnage = function () {
      pageIndex.value = 1;
    };

    watch(keyword, debounce(handleKeywordChnage, 400));
    onMounted(() => {// console.log('mounted');
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");

      return _openBlock(), _createElementBlock("div", {
        class: "container jumbotron jumbotron-fluid mb-3 pt-0 pb-0 bg-gray position-relative",
        style: {
          "margin-bottom": "5px"
        },
        id: `div-${__props.categoryInfo.sname}`,
        ref_key: "main",
        ref: main
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h5", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(__props.categoryInfo.aname), 1)]), _withDirectives(_createElementVNode("input", {
        class: "keyword-input",
        type: "text",
        placeholder: "标题关键字",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event)
      }, null, 512), [[_vModelText, keyword.value]])]), _hoisted_5, _createElementVNode("ol", {
        class: "list-group",
        id: ['ol-files-' + __props.categoryInfo.sname]
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentPageFiles), (file, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: "li-file d-flex",
          key: file.name
        }, [_createElementVNode("span", _hoisted_7, _toDisplayString(baseIndex.value + index + 1), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("h2", _hoisted_9, [_createVNode(_component_router_link, {
          class: "text-dark",
          to: {
            name: 'blog',
            params: {
              path: file.relapath,
              categorySname: probs.categoryInfo.sname,
              blogName: file.name
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(file.name), 1)]),
          _: 2
        }, 1032, ["to"])]), _hoisted_10, _createElementVNode("small", _hoisted_11, _toDisplayString(file.updatetime.year) + "年" + _toDisplayString(file.updatetime.mon) + "月" + _toDisplayString(file.updatetime.day) + "日 更新", 1)])]);
      }), 128))], 8, _hoisted_6), _unref(readMore) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-outline-secondary",
        onClick: _cache[1] || (_cache[1] = event => showAll())
      }, " View ALL ")])) : _createCommentVNode("", true), _unref(layaside) ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-outline-secondary",
        onClick: _cache[2] || (_cache[2] = event => layAside(event))
      }, " 收起 ")])) : _createCommentVNode("", true), !_unref(layaside) && _unref(totalPage) && _unref(totalPage) > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("p", _hoisted_15, " 总共 " + _toDisplayString(_unref(totalPage)) + " 页, 当前第 " + _toDisplayString(_unref(pageIndex)) + " " + " 页 ", 1), _createElementVNode("div", _hoisted_16, [_createElementVNode("button", {
        type: "button",
        onClick: _cache[3] || (_cache[3] = event => prePage(event)),
        class: _normalizeClass(["btn btn-sm mr-1", [_unref(pageIndex) <= 1 ? 'button-disabled btn-outline-danger' : 'btn-outline-secondary']])
      }, " 上一页 ", 2), _createElementVNode("button", {
        type: "button",
        style: {
          "margin-left": "8px"
        },
        onClick: _cache[4] || (_cache[4] = event => nextPage(event)),
        class: _normalizeClass(["btn btn-sm", [_unref(pageIndex) >= _unref(totalPage) ? 'button-disabled btn-outline-danger' : 'btn-outline-secondary']])
      }, " 下一页 ", 2)]), _createElementVNode("p", _hoisted_17, [_createTextVNode(" 每页 "), _withDirectives(_createElementVNode("select", {
        style: {
          "width": "min-content",
          "background-color": "inherit"
        },
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(max_file_items) ? max_file_items.value = $event : max_file_items = $event)
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(itemPerPageOptions, num => {
        return _createElementVNode("option", {
          key: num,
          label: num,
          value: num
        }, null, 8, _hoisted_18);
      }), 64))], 512), [[_vModelSelect, _unref(max_file_items)]]), _createTextVNode(" 条 ")])])) : _createCommentVNode("", true)], 8, _hoisted_1);
    };
  }

};